import { AppMainService } from './../../../../app-main.service';
import { ConfigurationService } from './../../../../configurations/configurationService';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { Status } from 'src/app/modules/shared/models/status';
import { WorkflowModelsNS } from '../../models/add-update-workflow.models';
import { AppMainComponent } from './../../../../app.main.component';
import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { ParseHelper } from './../../../../modules/shared/parse.helper';

@Component({
  selector: 'app-workflow-approvals-add-dialog',
  templateUrl: './workflow-approvals-add-dialog.component.html',
  styleUrls: ['./workflow-approvals-add-dialog.component.scss']
})
export class WorkflowApprovalsAddDialogComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() viewOnly: boolean = false;
    @Input() displayAddApproval: boolean = false;
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() selectedActionModule: any = null;
    @Input() selectedActionApprovals: WorkflowModelsNS.WorkflowAddEditActionApprovals[] = [];
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() savedApprovals = new EventEmitter<WorkflowModelsNS.WorkflowAddEditActionApprovals[]>();
    selectedModule: { objectId: number, name: string } = null;
    dropdownIcon: string = 'fa fa-caret-down';

    //Approvals Data
    approvalAddEditHeader: 'Add Approval' | 'Edit Approval' | 'View Approval' = 'Add Approval';
    approvalAddData: WorkflowModelsNS.WorkflowAddEditActionApprovals;

    assignedTypes = [
        {
            id: 1,
            name: 'Users'
        },
        // {
        //     id: 2,
        //     name: 'Roles'
        // }
    ];

    activeUsers: any[] = [];
    activeUserTree: any[] = [];
    //Workflow details form
    approvalDetailsForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();

    constructor(
        private formBuilder: FormBuilder,
        public app: AppMainComponent,
        private configService: ConfigurationService,
        private appMainService: AppMainService
    ) { }

    ngOnInit(): void {
        this.selectModuleAndChannel();
        this.initApprovalForm();
        this.loadDropdownValues();
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    selectModuleAndChannel(){
        if(this.selectedActionModule?.objectId && this.selectedActionModule?.objectId!=this.selectedParentModule?.objectId){
            this.selectedModule = ParseHelper.DeepCopy(this.selectedActionModule);
        }else{
            this.selectedModule = ParseHelper.DeepCopy(this.selectedParentModule);
        }
    }

    dialogClose(){
        this.initApprovalForm();
        this.displayAddApproval = false;
        this.dialogClosed.emit(true);
    }

    //Task Form
    initApprovalForm(){
        this.approvalAddEditHeader = 'Add Approval';
        this.detailsFormErrors = {};
        this.approvalDetailsForm = this.formBuilder.group({
            isApprovalSequenceEnabled: [true],
            approvals: this.formBuilder.array([this.createApprovalGroup()])
        });

        if(this.viewOnly){
            this.approvalDetailsForm.disable();
        }
    }

    createApprovalGroup(approvals: WorkflowModelsNS.WorkflowAddEditActionApprovals = null): FormGroup {
        const approvalForm = this.formBuilder.group({
            id: [approvals?.id||0],
            assignedType: [approvals?.assignedType||this.assignedTypes[0].id, Validators.required],
            roleId: [approvals?.roleId||0, Validators.required],
            assignedId: [approvals?.assignedUser||null, Validators.required]
        });

        if(this.viewOnly){
            approvalForm.disable();
        }

        return approvalForm;
    }

    get approvals(): FormArray {
        return this.approvalDetailsForm.get('approvals') as FormArray;
    }

    getApprovals(form) {
        return form.controls.approvals.controls;
    }

    addApproval(approvals: WorkflowModelsNS.WorkflowAddEditActionApprovals = null): void {
        this.approvals.push(this.createApprovalGroup(approvals));
    }

    removeApproval(index: number): void {
        if(this.getApprovals(this.approvalDetailsForm)?.length>1){
            this.approvals.removeAt(index);
        }
    }

    setApprovalEditData(selectedActionApproval: WorkflowModelsNS.WorkflowAddEditActionApprovals[]){
        this.approvals.clear();
        const isApprovalSequenceEnabled: boolean = !!(selectedActionApproval.find(a=> a.isApprovalSequenceEnabled));

        this.approvalDetailsForm.patchValue({
            isApprovalSequenceEnabled: true
        })

        selectedActionApproval.map(approvals=>{
            const userList = this.getFlatArrayFormChilren(this.activeUserTree)||[];
            let assignedUser = userList.find(user => user.id == approvals.assignedId);
            this.addApproval({...approvals, assignedUser: assignedUser});
        })
    }

    saveApproval(){

        if (this.approvalDetailsForm.invalid) {
            // this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        const formData = this.approvalDetailsForm.getRawValue();

        const approvalData: WorkflowModelsNS.WorkflowAddEditActionApprovals[] = [];
        formData.approvals.map((approval, index)=>{
            approvalData.push({
                id: approval?.id||0,
                workflowActionId: 0,
                objectId: this.selectedModule.objectId,
                objectName: this.selectedModule.name,
                assignedType: approval.assignedType,
                roleId: approval.roleId,
                assignedId: approval.assignedId?.id,
                approvalSequence: index + 1,
                isApprovalSequenceEnabled: formData.isApprovalSequenceEnabled,
                statusId: Status.Active
            })
        });

        this.savedApprovals.emit(approvalData);
        this.dialogClose();
    }

    //Load Dropdown Value
    loadPreLoadedData(){
        this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
        this.getUserTree();
    }

    loadDropdownValues(){
        this.loadPreLoadedData();
    }

    getUserTree(){
        this.appMainService.isShowSpinner('approvalList');
        this.configService.getAllUserOrgChartData(this.app.userId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                if(response){
                    this.activeUserTree = this.copyUserTree(response);
                    if(this.selectedActionApprovals?.length>0){
                        this.setApprovalEditData(this.selectedActionApprovals)
                    }
                }
                this.appMainService.isHideSpinner('approvalList');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('approvalList');
            }
        })
    }

    copyUserTree(originalTree: Array<object>): Array<object> {
        return originalTree.map(({ childUsers, ...data }: any) => ({
            id: data.id,
            label: `${data.name}${data?.role ? (data.name ? ' - ' : '') + data?.role : ''}`,
            name: data.name,
            selectable: true,
            children: this.copyUserTree(childUsers)
        }));
    }

    getFlatArrayFormChilren(members: any[]){
        let children = [];
        return members.map(m => {
          if (m.children && m.children.length) {
            children = [...children, ...m.children];
          }
          return m;
        }).concat(children.length ? this.getFlatArrayFormChilren(children) : children);
    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
